import React from "react";
import LeafletMap from "./LeafletMap";

export default function PointMap({ item, lang }) {
  if (!item || !item.location) return null;

  const { latitude, longitude } = item.location;

  return <LeafletMap lat={latitude} lng={longitude} zoom={13} editable={false} height={320} />;
}
